import {
  DomesticExtractionFields,
  ExtractionFieldValue,
  ResolvedExtractionFields,
  SwiftExtractionFields,
} from "@investorRequest/models/bankExtraction";

/** Maps domestic-rail extraction keys to customFields keys used by WireInstructionsRequest. */
export const DOMESTIC_EXTRACTION_TO_FORM_FIELD: Record<keyof DomesticExtractionFields, string> = {
  beneficiaryAccountName: "beneficiaryAccountName",
  bankName: "bankName",
  routingNumber: "routingNumber",
  accountNumber: "bankAccountNumber",
  swiftCode: "SwiftId",
  intermediaryYesNo: "intermediaryYesNo",
  intermediarySwiftOrAba: "intermediarySwiftOrAba",
  intermediaryRoutingNumber: "intermediaryRoutingNumber",
  intermediaryPaymentMessage: "intermediaryPaymentMessage",
  furtherCreditYesNo: "furtherCreditYesNo",
  furtherCreditLine1: "furtherCreditLine1",
  furtherCreditLine2: "furtherCreditLine2",
  furtherCreditLine3: "furtherCreditLine3",
};

/** Maps SWIFT-rail extraction keys (domestic set + IBAN) to customFields keys. */
export const SWIFT_EXTRACTION_TO_FORM_FIELD: Record<keyof SwiftExtractionFields, string> = {
  ...DOMESTIC_EXTRACTION_TO_FORM_FIELD,
  iban: "IBAN",
};

export const FORM_TO_EXTRACTION_FIELD: Record<string, keyof SwiftExtractionFields> = Object.entries(
  SWIFT_EXTRACTION_TO_FORM_FIELD
).reduce((acc, [extractionKey, formKey]) => {
  acc[formKey] = extractionKey as keyof SwiftExtractionFields;

  return acc;
}, {} as Record<string, keyof SwiftExtractionFields>);

export type ExtractionFormFieldEntry = {
  formKey: string;
  extractionKey: keyof DomesticExtractionFields | keyof SwiftExtractionFields;
  field: ExtractionFieldValue;
};

const EXTRACTION_TO_FORM_FIELD_BY_RAIL = {
  ach: DOMESTIC_EXTRACTION_TO_FORM_FIELD,
  fedwire: DOMESTIC_EXTRACTION_TO_FORM_FIELD,
  swift: SWIFT_EXTRACTION_TO_FORM_FIELD,
} as const;

export const getFormFieldEntries = (resolved: ResolvedExtractionFields): ExtractionFormFieldEntry[] => {
  const mapping = EXTRACTION_TO_FORM_FIELD_BY_RAIL[resolved.rail];

  return (Object.keys(mapping) as Array<keyof typeof mapping>).map((extractionKey) => ({
    formKey: mapping[extractionKey],
    extractionKey,
    field: resolved.fields[extractionKey as keyof typeof resolved.fields],
  }));
};
